import * as basicScroll from 'basicscroll'

const direct = true
const from = 'middle-bottom'
const to = 'bottom-top'

const scrolls = [
	{ 
		el: '.about .half-oval',
		props: {
			'--ty': {
				from: '100%',
				to: '0%'
			}
		}
	},
	{ 
		el: '.specialities .triangle',
		props: {
			'--ty': {
				from: '100%',
				to: '0%'
			}
		}
	},
	{
		el: '.specialities .trapezoid',
		props: {
			'--ty': {
				from: '200%',
				to: '50%'
			}
		}
	},
	{
		el: '.ddd .oval',
		props: {
			'--ty': {
				from: '100%',
				to: '0%'
			}
		}
	},
	{
		el: '.ddd .rectangle',
		props: {
			'--ty': {
				from: '100%',
				to: '0%'
			}
		}
	},
	{
		el: '.faq .rectangle',
		props: {
			'--ty': {
				from: '150%',
				to: '-100%'
			}
		}
	},
	{
		el: '.testimonials .rectangle',
		props: {
			'--ty': {
				from: '150%',
				to: '-100%'
			}
		}
	},
	{
		el: '.testimonials .half-oval',
		props: {
			'--ty': {
				from: '150%',
				to: '-100%'
			}
		}
	},
	{
		el: '.portfolio .oval',
		props: {
			'--ty': {
				from: '150%',
				to: '-100%'
			}
		}
	},
	{
		el: '.services .trapezoid',
		props: {
			'--ty': {
				from: '150%',
				to: '-100%'
			}
		}
	},
	{
		el: '.specialities .oval',
		props: {
			'--ty': {
				from: '150%',
				to: '-100%'
			}
		}
	}
]


scrolls.forEach(scroll => {
	const parallax = basicScroll.create({
		elem: document.querySelector(scroll.el),
		props: scroll.props,
		from,
		to,
		direct,
	})
	parallax.start()
})